<template>
    <div class="modal custom_question_modal" :class="{ 'open_modal': showConsultationRequestModal}">
        <div class="modal_overlay"></div>
        <div class="modal_inner">
            <div class="modal_header">
                <span class="close_icon close_icon_sm" @click="closeConsultationModal()">×</span>
                <h2>상담내역</h2>
            </div>
            <div class="modal_wrapper">
                <div class="modal_content p_20" v-if="consultationData">
                    <div class="table_responsive">
                        <table class="table table_bordered">
                            <tbody>
                                <tr>
                                    <td rowspan="2">문의종류</td>
                                    <td rowspan="2">{{ consultationData.inquiry_type ? consultationData.inquiry_type.name : '' }}</td>
                                    <td >학부모 아이디</td>
                                    <td>{{ consultationData.parent ? consultationData.parent.email : '' }}</td>
                                    <td>학부모명</td>
                                    <td>{{ consultationData.parent ? consultationData.parent.name : '' }}</td>
                                </tr>
                                <tr>
                                    <td >학생 아이디</td>
                                    <td >{{ consultationData.student ? consultationData.student.student_id : '' }}</td>
                                    <td>학생명</td>
                                    <td>{{ consultationData.student ? consultationData.student.name : '' }}</td>
                                </tr>
                                <tr>
                                    <td >제목 </td>
                                    <td colspan="5" class="text_left">{{ consultationData.title }}</td>
                                    
                                </tr>
                                <tr>
                                    <td >첨부파일 </td>
                                    <td colspan="5" class="text_left" v-if="consultationData.original_filename">
                                        <div class="file_link"><span @click.prevent="downLoadAttachment()">{{ consultationData.original_filename }}</span></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td >내용 </td>
                                    <td colspan="5" class="text_center">
                                        <div class="text">{{ consultationData.details }}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td rowspan="2">답변 </td>
                                    <td colspan="5" >에디터</td>
                                </tr>
                                <tr>
                                    <td colspan="5" >
                                        <div class="row">
                                            <div class="col_12">
                                                <div :class="['form-group', {'has_error': errorFor('answer')}]">
                                                    <text-editor-component :id="'answer'" :existingData="form.answer ? form.answer : ''" @change="changeEditorValue" />
                                                    <v-errors :errors="errorFor('answer')" />
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                <!-- <tr>
                                    <td>링크</td>
                                    <td colspan="5" >
                                        https://sungwoosolution.net/subject-learnings/daily-exam/95/4016
                                    </td>
                                </tr> -->
                                <tr>
                                    <td>상태</td>
                                    <td colspan="2" >
                                        <div :class="['form-group', {'has_error': errorFor('status')}]">
                                            <div class="form_inline">
                                                <div class="form_radio">
                                                    <input type="radio" id="waiting" value="waiting" v-model="form.answer_complete">
                                                    <label for="waiting">답변대기</label>
                                                </div>
                                                <div class="form_radio">
                                                    <input type="radio" id="completed" value="completed" v-model="form.answer_complete">
                                                    <label for="completed">완료</label>
                                                </div>
                                            </div>
                                            <v-errors :errors="errorFor('status')" />
                                        </div>
                                    </td>
                                    <td class="text_center">
                                        <button class="btn btn_blue" @click.prevent="submit()">저장</button>
                                    </td>
                                    <td class="text_center">
                                        <button class="btn btn_info" @click.prevent="closeConsultationModal(row)">목록</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import TextEditorComponent from "@/components/TextEditorComponent";
    export default {
        name:'consultation-modal',
        emits: ["closeModal"],
        components:{TextEditorComponent},
        data(){
            return{
                baseUrl: process.env.VUE_APP_BASE,
                form:{
                    answer: '',
                    answer_complete: '',
                }
            }
        },
        props:{
            showConsultationRequestModal:{
                type: Boolean,
                required: true
            },
            consultationData:{
                type: Object,
                required: true
            },
        },
        created() {
            

        },  
        mounted(){
            if(this.consultationData){
                this.form.answer = this.consultationData.answer
                this.form.answer_complete = this.consultationData.answer_complete
            }
        },
        updated(){
            
        },
        methods:{
            changeEditorValue(editorId, data) {
                this.form[editorId] = data
            },
            closeConsultationModal(){
                this.$emit("closeModal");
            },

            async downLoadAttachment(){
                await this.axios.get('/consultation-attachment-download-file/' + this.consultationData.id, {responseType: 'arraybuffer',})
                .then(({data}) => {
                    this.fileDownload(data, this.consultationData.original_filename)
                })
            },
            fileDownload(data, filename) {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
            },

            submit() {
                this.allErrors = null;
                this.loading = true;

                this.axios.patch('/consultations/' + this.consultationData.id, this.form)
                    .then(() => {
                        this.closeConsultationModal();
                        this.showSuccessMsg(this.$t('common.addSuccess'))
                    })
                    .catch((err) => {
                        this.allErrors = err.response.data.errors;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        }
    }
</script>
<style scoped>
    .table tr td{
        white-space : normal;
    }
    .file_link span{
        cursor: pointer;
        text-decoration: underline;
        color: blue;
    }
</style>